import React, { useState } from "react";

// Microkomponent: Administrer telefoni (SIP-konfigurasjon + diagnostikk)
export default function AdministerVoipModule() {
  const isAdmin = false; // byttes til ekte permission-sjekk i Chamcore

  const [provider, setProvider] = useState("CloudSupplier");
  const [incomingIp, setIncomingIp] = useState("213.52.86.117");
  const [outgoingIp, setOutgoingIp] = useState("213.52.86.118");
  const [mainNumber, setMainNumber] = useState("+47 21040788");

  const [diagOpen, setDiagOpen] = useState(false);
  const [diagRunId, setDiagRunId] = useState(0);

  type Status = "idle" | "running" | "ok" | "warning" | "error";

  const [dnsStatus, setDnsStatus] = useState<Status>("idle");
  const [portStatus, setPortStatus] = useState<Status>("idle");
  const [latencyStatus, setLatencyStatus] = useState<Status>("idle");
  const [regStatus, setRegStatus] = useState<Status>("idle");

  const [dnsInfo, setDnsInfo] = useState("-");
  const [portInfo, setPortInfo] = useState("-");
  const [latencyInfo, setLatencyInfo] = useState("-");
  const [regInfo, setRegInfo] = useState("-");

  const statusClasses = (status: Status) => {
    if (status === "ok") return "bg-emerald-50 text-emerald-700 border-emerald-200";
    if (status === "warning") return "bg-amber-50 text-amber-700 border-amber-200";
    if (status === "error") return "bg-rose-50 text-rose-700 border-rose-200";
    if (status === "running") return "bg-slate-50 text-slate-600 border-slate-200";
    return "bg-slate-50 text-slate-500 border-slate-200";
  };

  const runDiagnostics = () => {
    setDiagRunId((id) => id + 1);
    const currentRun = diagRunId + 1;

    setDnsStatus("running");
    setPortStatus("running");
    setLatencyStatus("running");
    setRegStatus("running");

    setDnsInfo("Løser DNS mot leverandør...");
    setPortInfo("Tester port 5060 (UDP)...");
    setLatencyInfo("Måler round-trip latency...");
    setRegInfo("Sender SIP OPTIONS mot trunk...");

    // DNS
    setTimeout(() => {
      if (currentRun !== diagRunId + 0) return;
      setDnsStatus("ok");
      setDnsInfo(`213.52.86.117 løst på 32 ms`);
    }, 500);

    // Port
    setTimeout(() => {
      if (currentRun !== diagRunId + 0) return;
      setPortStatus("ok");
      setPortInfo("Port 5060 (UDP) svarer innen 41 ms");
    }, 800);

    // Latency
    setTimeout(() => {
      if (currentRun !== diagRunId + 0) return;
      setLatencyStatus("ok");
      setLatencyInfo("3 prøver: min 38 ms / maks 55 ms / snitt 44 ms");
    }, 1100);

    // Registration
    setTimeout(() => {
      if (currentRun !== diagRunId + 0) return;
      setRegStatus("ok");
      setRegInfo("SIP 200 OK på OPTIONS – trunk registrert og tilgjengelig");
    }, 1400);
  };

  const openDiagnostics = () => {
    setDiagOpen(true);
    // reset & run
    setDnsStatus("idle");
    setPortStatus("idle");
    setLatencyStatus("idle");
    setRegStatus("idle");
    setDnsInfo("-");
    setPortInfo("-");
    setLatencyInfo("-");
    setRegInfo("-");
    runDiagnostics();
  };

  const handleSave = () => {
    if (!isAdmin) return;
    // kobles mot backend senere
    alert("SIP-konfig lagret (demo)");
  };

  return (
    <div className="min-h-screen bg-slate-50 px-4 py-6 sm:px-8 sm:py-10 text-slate-900">
      <div className="max-w-5xl mx-auto">
        <header className="mb-6 flex items-center justify-between gap-4">
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold text-slate-900">Administrer telefoni</h1>
            <p className="text-sm text-slate-500 mt-1">
              SIP-trunk konfigurasjon, hovednummer og teknisk diagnostikk.
            </p>
          </div>
          <span className="inline-flex items-center rounded-full border border-slate-200 bg-white px-3 py-1 text-xs text-slate-600">
            Microkomponent · Chamcore
          </span>
        </header>

        {/* SIP KONFIG */}
        <section className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 mb-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
            <div>
              <h2 className="text-lg font-semibold text-slate-900">SIP-konfigurasjon</h2>
              <p className="text-sm text-slate-500 mt-1">
                Verdier mottatt fra telefoni-leverandør. Endringer krever admin-tilgang.
              </p>
            </div>
            <div className="flex items-center gap-2 text-xs text-slate-500">
              <span className="inline-flex h-2 w-2 rounded-full bg-emerald-500" />
              <span>Trunk online (demo)</span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <div className="space-y-1">
              <label className="text-xs font-medium text-slate-500">Leverandør</label>
              <select
                value={provider}
                onChange={(e) => setProvider(e.target.value)}
                className="w-full rounded-xl border border-slate-300 bg-slate-50 px-3 py-2 text-sm focus:border-slate-500 focus:outline-none"
              >
                <option value="CloudSupplier">CloudSupplier (SIP)</option>
                <option value="Twilio">Twilio</option>
                <option value="ChamcoreKamailio">Chamcore Kamailio</option>
                <option value="Other">Annen leverandør</option>
              </select>
            </div>

            <div className="space-y-1">
              <label className="text-xs font-medium text-slate-500">Hovednummer</label>
              <input
                value={mainNumber}
                onChange={(e) => setMainNumber(e.target.value)}
                className="w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm focus:border-slate-500 focus:outline-none"
              />
            </div>

            <div className="space-y-1">
              <label className="text-xs font-medium text-slate-500">Incoming SIP IP (til deg)</label>
              <input
                value={incomingIp}
                onChange={(e) => setIncomingIp(e.target.value)}
                className="w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm font-mono focus:border-slate-500 focus:outline-none"
              />
              <p className="text-[11px] text-slate-400">Eksempel fra leverandør: "IP for incoming calls to you is 213.52.86.117"</p>
            </div>

            <div className="space-y-1">
              <label className="text-xs font-medium text-slate-500">Outgoing SIP IP (fra deg)</label>
              <input
                value={outgoingIp}
                onChange={(e) => setOutgoingIp(e.target.value)}
                className="w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm font-mono focus:border-slate-500 focus:outline-none"
              />
              <p className="text-[11px] text-slate-400">Eksempel: "Outgoing IP from you is 213.52.86.118"</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div className="text-xs text-slate-500 flex items-center gap-2">
              {!isAdmin && (
                <>
                  <span className="inline-flex h-4 w-4 items-center justify-center rounded-full bg-slate-100 text-[10px] font-semibold text-slate-500">
                    !
                  </span>
                  <span>Endringer kan kun lagres av administrator. Kontakt systemeier for å oppdatere trunk.</span>
                </>
              )}
              {isAdmin && <span>Du har administrator-tilgang. Husk å lagre endringer.</span>}
            </div>
            <div className="flex flex-wrap gap-3 justify-end">
              <button
                type="button"
                onClick={openDiagnostics}
                className="rounded-full border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
              >
                Test SIP-tilkobling
              </button>
              <button
                type="button"
                onClick={handleSave}
                disabled={!isAdmin}
                className={`rounded-full px-5 py-2 text-sm font-semibold shadow-sm transition ${
                  isAdmin
                    ? "bg-slate-900 text-white hover:bg-black"
                    : "bg-slate-200 text-slate-500 cursor-not-allowed"
                }`}
              >
                Lagre konfig
              </button>
            </div>
          </div>
        </section>

        {/* TILKNYTTEDE NUMMER (enkel liste, kan brytes ut til egen modul senere) */}
        <section className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-4">
            <div>
              <h2 className="text-lg font-semibold text-slate-900">Tilknyttede numre</h2>
              <p className="text-sm text-slate-500 mt-1">Systemnumre koblet til denne SIP-trunken.</p>
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-slate-200 text-left text-xs text-slate-500">
                  <th className="py-2 pr-4">Nummer</th>
                  <th className="py-2 pr-4">Beskrivelse</th>
                  <th className="py-2 pr-4">Status</th>
                  <th className="py-2 pr-4">Rolle</th>
                  <th className="py-2">Handlinger</th>
                </tr>
              </thead>
              <tbody>
                {[
                  {
                    number: mainNumber,
                    desc: "Hovednummer / IVR inngang",
                    status: "Aktiv",
                    role: "Hovednummer",
                  },
                  {
                    number: "+47 21040789",
                    desc: "Backup trunk / support-kø",
                    status: "Aktiv",
                    role: "Backup",
                  },
                ].map((n) => (
                  <tr key={n.number} className="border-b border-slate-100 last:border-b-0">
                    <td className="py-2 pr-4 font-mono text-xs sm:text-sm">{n.number}</td>
                    <td className="py-2 pr-4 text-slate-700">{n.desc}</td>
                    <td className="py-2 pr-4">
                      <span className="inline-flex items-center rounded-full bg-emerald-50 px-2.5 py-0.5 text-xs font-medium text-emerald-700">
                        ● {n.status}
                      </span>
                    </td>
                    <td className="py-2 pr-4 text-xs text-slate-600">{n.role}</td>
                    <td className="py-2 flex flex-wrap gap-2">
                      <button
                        type="button"
                        onClick={openDiagnostics}
                        className="rounded-full border border-slate-200 bg-white px-3 py-1 text-xs text-slate-700 hover:bg-slate-50"
                      >
                        Test tilkobling
                      </button>
                      <button
                        type="button"
                        className="rounded-full border border-slate-200 bg-white px-3 py-1 text-xs text-slate-500 hover:bg-slate-50"
                      >
                        Administrer
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </div>

      {/* DIAGNOSTICS MODAL */}
      {diagOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 py-6">
          <div className="w-full max-w-2xl rounded-2xl bg-white p-6 shadow-xl">
            <div className="mb-4 flex items-start justify-between gap-4">
              <div>
                <h3 className="text-lg font-semibold text-slate-900">SIP-diagnostikk</h3>
                <p className="text-sm text-slate-500 mt-1">
                  Alle tester kjører parallelt. Resultatene oppdateres fortløpende.
                </p>
              </div>
              <button
                type="button"
                onClick={() => setDiagOpen(false)}
                className="text-slate-400 hover:text-slate-600"
              >
                ✕
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              {/* DNS */}
              <div className={`rounded-xl border p-4 text-sm ${statusClasses(dnsStatus)}`}>
                <div className="mb-1 flex items-center justify-between">
                  <span className="font-medium">DNS-oppslag</span>
                  <span className="text-[11px] uppercase tracking-wide">
                    {dnsStatus === "running" && "KJØRER"}
                    {dnsStatus === "ok" && "OK"}
                    {dnsStatus === "idle" && "VENTER"}
                  </span>
                </div>
                <p className="text-xs mt-1">{dnsInfo}</p>
              </div>

              {/* PORT */}
              <div className={`rounded-xl border p-4 text-sm ${statusClasses(portStatus)}`}>
                <div className="mb-1 flex items-center justify-between">
                  <span className="font-medium">Port 5060 tilgjengelighet</span>
                  <span className="text-[11px] uppercase tracking-wide">
                    {portStatus === "running" && "KJØRER"}
                    {portStatus === "ok" && "OK"}
                    {portStatus === "idle" && "VENTER"}
                  </span>
                </div>
                <p className="text-xs mt-1">{portInfo}</p>
              </div>

              {/* LATENCY */}
              <div className={`rounded-xl border p-4 text-sm ${statusClasses(latencyStatus)}`}>
                <div className="mb-1 flex items-center justify-between">
                  <span className="font-medium">Latency-måling</span>
                  <span className="text-[11px] uppercase tracking-wide">
                    {latencyStatus === "running" && "KJØRER"}
                    {latencyStatus === "ok" && "OK"}
                    {latencyStatus === "idle" && "VENTER"}
                  </span>
                </div>
                <p className="text-xs mt-1">{latencyInfo}</p>
              </div>

              {/* REGISTRATION */}
              <div className={`rounded-xl border p-4 text-sm ${statusClasses(regStatus)}`}>
                <div className="mb-1 flex items-center justify-between">
                  <span className="font-medium">SIP-registrering</span>
                  <span className="text-[11px] uppercase tracking-wide">
                    {regStatus === "running" && "KJØRER"}
                    {regStatus === "ok" && "OK"}
                    {regStatus === "idle" && "VENTER"}
                  </span>
                </div>
                <p className="text-xs mt-1">{regInfo}</p>
              </div>
            </div>

            <div className="mt-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <div className="text-xs text-slate-500">
                Denne testen er en visuell simulering. I produksjon kobles den mot Chamcore sitt
                backend-monitoreringslag for ekte SIP-statuser.
              </div>
              <div className="flex flex-wrap gap-2 justify-end">
                <button
                  type="button"
                  onClick={runDiagnostics}
                  className="rounded-full border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
                >
                  Kjør test på nytt
                </button>
                <button
                  type="button"
                  onClick={() => setDiagOpen(false)}
                  className="rounded-full bg-slate-900 px-5 py-2 text-sm font-semibold text-white hover:bg-black"
                >
                  Lukk
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
